import { MoneyInput } from "@equidefi/ui/forms";
import type { MoneyInputProps } from "@equidefi/ui/forms/MoneyInput";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartMoneyInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<MoneyInputProps, "name" | "value" | "onChange" | "onBlur" | "error" | "isInvalid"> & {
  name: TName;
};

function SmartMoneyInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...moneyProps }: SmartMoneyInputProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <MoneyInput
      name={field.name}
      ref={field.ref}
      value={field.value ?? ""}
      onChange={(value) => field.onChange(value ?? null)}
      onBlur={field.onBlur}
      isInvalid={!!error}
      error={error?.message}
      {...moneyProps}
    />
  );
}

export default SmartMoneyInput;
